export const actions = {
  syncStates({ commit, dispatch }) {
    commit('offline/RESET')
    setTimeout(() => dispatch('routePlan/fetchAvailable', true))
    setTimeout(() => dispatch('forms/fetchAvailable'))
    setTimeout(() => dispatch('parameters/fetchAvailable'))
    setTimeout(() => dispatch('hierarchy/fetchHierarchy'))
    setTimeout(() => dispatch('portfolio/fetchPortfolio'))
    setTimeout(() => dispatch('clientOptions/fetchClientOptions'))
    setTimeout(() => dispatch('coaching/serverSync'))
    setTimeout(() => dispatch('research/serverSync'))
  },
}
